import React, { useReducer, useState } from 'react';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControl, IconButton } from '@mui/material';
import GoogleAutocomplete from '../../../components/googleautocomplete/googleautocomplete.component';
// import { CustomDateTimePicker } from '../../../components/datetimepicker';
// import dayjs from 'dayjs';
import Grid from '@mui/material/Grid2';
// import useFetchTests from './hooks/useFetchTests';
import httpClient from '../../../services/http';
import { APIUtils } from '../../../utils/apiutils';
import PropTypes from 'prop-types';
import Spinner from '../../../components/spinner/spinner';
import Swal from 'sweetalert2';
import { CUSTOM_EVENTS } from '../../../utils/constants';

const SaveCityBtn = ({cityData, closeDialog}) => {
    const [loading, setLoading] = useState(false);

    const isValid = () => {
        if (!cityData.location) {
            return false;
        }
        return true;
    };

    const handleSave = async () => {
        if (!isValid()) {
            return;
        }
        setLoading(true);
        const {err, res} = await httpClient.post(APIUtils.getAdminAPIEndpoint('admin:add-city'), cityData).then(res => ({err: null, res: res.data})).catch(err => ({err, res: null}));
        setLoading(false);
        if (err) {
            Swal.fire('Something Went Wrong!', err.cause.response.data.message, 'error');
            return;
        }

        document.dispatchEvent(new CustomEvent(CUSTOM_EVENTS.REFETCH_CITIES));
        Swal.fire(res.message, '', 'success');
        closeDialog();
    };

    const btnContent = () => {
        if (loading) {
            return <>Saving&nbsp;<Spinner /></>;
        }

        return 'Save';
    };

    return (
        <FormControl >
            <Button variant='contained' color='primary' onClick={handleSave} disabled={!isValid()}>{btnContent()}</Button>
        </FormControl>
    );
};
SaveCityBtn.propTypes = {
    cityData: PropTypes.object.isRequired,
    closeDialog: PropTypes.func,
};

const AddCity = () => {
    const FORM_DATA = {
        coordinate: {lat: 0, lng: 0},
        location: '',
    };
    const [open, setOpen] = useState(false);
    const [ cityData, updateCityData ] = useReducer((prev, next) => {
        return {...prev, ...next};
    }, FORM_DATA);

    const handleDialog = (toggle) => () => {
        setOpen(toggle);
        if (!toggle) {
            updateCityData({ ...FORM_DATA });
        }
    };

    const handleLocation = (locData) => {
        let loc = '';
        let coord = {lat: 0, lng: 0};
        if (locData) {
            const {address_components: addressComponents, formatted_address: formattedAddress, geometry: { location: { lat, lng } }} = locData;
            loc = formattedAddress;
            const city = addressComponents.find(component => component.types.includes('locality'));
            if (city && city.long_name) {
                loc = city.long_name;
            }
            coord = { lat: lat(), lng: lng() };
        }
        updateCityData({ location: loc, coordinate: coord });
    };

    const addCityDialog = (
        <Dialog open={open} maxWidth='sm' fullWidth className='has-autocomplete'>
            <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                <div style={{ flex: 1 }}>Add City</div>
                <IconButton onClick={handleDialog(false)} size='small'>
                    <CloseOutlinedIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Grid container className='profile-grid' spacing={3}>
                    <Grid size={{ xs: 12, md: 12, sm: 12 }} sx={{ paddingTop: '.5rem' }}>
                        <GoogleAutocomplete
                            setAddress={handleLocation}
                            address={cityData.location}
                            textFieldProps={{ size: 'small', label: 'City', placeholder: 'City' }}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <Divider />
            <DialogActions>
                <FormControl>
                    <Button variant='outlined' color='secondary' onClick={handleDialog(false)}>Cancel</Button>
                </FormControl>
                <SaveCityBtn cityData={cityData} closeDialog={handleDialog(false)} />
            </DialogActions>
        </Dialog>
    );
    return (
        <>
            {addCityDialog}
            <div className="centerContent">
                <Button
                    size='small'
                    variant='contained'
                    sx={{ mr: 1 }}
                    color='primary'
                    onClick={handleDialog(true)}
                >
                    Add City
                </Button>
            </div>
        </>
    );
};

export default AddCity;